export enum TimingRepeatType {
  PERIOD = 'PERIOD',
  DAILY = 'DAILY',
  NONE = 'NONE',
}
